import React, { Component } from "react";
import TokenService from "../../services/token-service";
import AuthApiService from "../../services/auth-api-service";
import { Button, Input } from "../Utils/Utils";
import "./LoginFormcss.css";

export default class LoginForm extends Component {
  static defaultProps = {
    onLoginSuccess: () => {}
  };

  state = { error: null };

  handleSubmitWithJwtAuth = ev => {
    ev.preventDefault();
    this.setState({ error: null });
    const { username, password } = ev.target;

    //console.log(username.value, password.value);
    AuthApiService.postLogin({
      username: username.value,
      password: password.value
    })
      .then(res => {
        username.value = "";
        password.value = "";
        TokenService.saveAuthToken(res.authToken);
        this.props.onLoginSuccess();
      })
      .catch(res => {
        this.setState({ error: res.error });
      });
  };

  render() {
    const { error } = this.state;
    return (
      <form className="LoginForm" onSubmit={this.handleSubmitWithJwtAuth}>
        <div role="alert">{error && <p className="red">{error}</p>}</div>
        <div className="UserName">
          <label htmlFor="LoginForm__username">User name</label>
          <Input
            required
            type="user_name"
            name="username"
            id="LoginForm__username"
          ></Input>
        </div>
        <div className="Password">
          <label htmlFor="LoginForm__password">Password</label>
          <Input
            required
            name="password"
            type="password"
            id="LoginForm__password"
          ></Input>
        </div>
        <Button className="LoginButton" type="submit">Login</Button>
      </form>
    );
  }
}
